(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
(function () {
  /* -- Reading progress bar -- */
  var bar     = document.getElementById('art-progress');
  var content = document.getElementById('art-content');

  function updateProgress() {
    if (!bar || !content) return;
    var rect     = content.getBoundingClientRect();
    var total    = content.offsetHeight;
    var scrolled = Math.max(0, -rect.top);
    bar.style.width = Math.min(100, total > 0 ? (scrolled / total) * 100 : 0).toFixed(1) + '%';
  }

  if (bar && content) {
    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  /* -- Copy link button -- */
  var copyBtns = document.querySelectorAll('.art-copy-btn');
  if (!copyBtns.length) return;

  var CHECK = '<polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>';
  var COPY  = '<rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>';

  copyBtns.forEach(function (btn) {
    var timer;
    var icon = btn.querySelector('.art-copy-icon');

    btn.addEventListener('click', function () {
      clearTimeout(timer);
      var url = btn.dataset.url || window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { showCheck(btn, icon); }).catch(function () { fallback(btn, icon, url); });
      } else {
        fallback(btn, icon, url);
      }
      timer = setTimeout(function () {
        btn.classList.remove('is-copied');
        if (icon) icon.innerHTML = COPY;
      }, 2500);
    });
  });

  function fallback(btn, icon, url) {
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.style.cssText = 'position:fixed;opacity:0;';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); showCheck(btn, icon); } catch (_) {}
    document.body.removeChild(ta);
  }

  function showCheck(btn, icon) {
    btn.classList.add('is-copied');
    if (icon) icon.innerHTML = CHECK;
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-showcase"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cat-showcase__viewport--desk-slider').forEach(function (viewport) {
  var list    = viewport.querySelector('.cat-showcase__list');
  var btnPrev = viewport.querySelector('.cat-showcase__arrow--prev');
  var btnNext = viewport.querySelector('.cat-showcase__arrow--next');
  if (!list || !btnPrev || !btnNext) return;

  function cardStep() {
    var card = list.querySelector('.need-card');
    return card ? card.offsetWidth + 14 : 220;
  }

  function updateArrows() {
    btnPrev.classList.toggle('is-hidden', list.scrollLeft <= 4);
    btnNext.classList.toggle('is-hidden', list.scrollLeft + list.offsetWidth >= list.scrollWidth - 4);
  }

  btnPrev.addEventListener('click', function () {
    list.scrollBy({ left: -cardStep() * 2, behavior: 'smooth' });
  });

  btnNext.addEventListener('click', function () {
    list.scrollBy({ left: cardStep() * 2, behavior: 'smooth' });
  });

  list.addEventListener('scroll', updateArrows, { passive: true });
  updateArrows();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.querySelector('[data-read-more]');
  if (!btn) return;
  var descId = btn.getAttribute('aria-controls');
  var descEl = document.getElementById(descId);
  var gradientEl = btn.previousElementSibling;
  var textEl = btn.querySelector('[data-read-more-text]');
  var moreLabel = textEl ? textEl.textContent : '';
  var lessLabel = btn.dataset.readLessText || moreLabel;

  btn.addEventListener('click', function () {
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      descEl.classList.add('col-header__desc--collapsed');
      if (gradientEl) gradientEl.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
      if (textEl) textEl.textContent = moreLabel;
    } else {
      descEl.classList.remove('col-header__desc--collapsed');
      if (gradientEl) gradientEl.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      if (textEl) textEl.textContent = lessLabel;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {

  /* -- Sidebar -- */
  var sidebar = document.getElementById('col-sidebar');
  var overlay = document.getElementById('col-sidebar-overlay');

  if (sidebar && overlay) {
    function openSidebar() {
      sidebar.classList.add('is-open');
      overlay.classList.add('is-open');
      overlay.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      document.querySelectorAll('[data-sidebar-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }

    function closeSidebar() {
      sidebar.classList.remove('is-open');
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.querySelectorAll('[data-sidebar-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    document.querySelectorAll('[data-sidebar-toggle]').forEach(function (btn) {
      btn.addEventListener('click', openSidebar);
    });
    document.querySelectorAll('[data-sidebar-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSidebar);
    });
    overlay.addEventListener('click', closeSidebar);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeSidebar();
    });
  }

  /* -- Filter groups -- */
  function bindGroups() {
    document.querySelectorAll('.filter-group__toggle').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var group = btn.closest('.filter-group');
        var isOpen = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(isOpen));
      });
    });
  }
  bindGroups();

  /* -- Expand all / Collapse all -- */
  var expandBtn = document.querySelector('[data-expand-all]');
  if (expandBtn) {
    var expandText   = expandBtn.dataset.expandText;
    var collapseText = expandBtn.dataset.collapseText;

    function allGroupsOpen() {
      return Array.from(document.querySelectorAll('.filter-group')).every(function (g) {
        return g.classList.contains('is-open');
      });
    }

    expandBtn.textContent = allGroupsOpen() ? collapseText : expandText;

    expandBtn.addEventListener('click', function () {
      var shouldOpen = !allGroupsOpen();
      document.querySelectorAll('.filter-group').forEach(function (g) {
        g.classList.toggle('is-open', shouldOpen);
      });
      document.querySelectorAll('.filter-group__toggle').forEach(function (t) {
        t.setAttribute('aria-expanded', String(shouldOpen));
      });
      expandBtn.textContent = shouldOpen ? collapseText : expandText;
    });

    /* Keep button text in sync after individual toggles */
    document.querySelectorAll('.filter-group__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        expandBtn.textContent = allGroupsOpen() ? collapseText : expandText;
      });
    });
  }

  /* -- Show more / Show less -- */
  document.querySelectorAll('[data-show-more]').forEach(function (btn) {
    var list = btn.closest('.filter-group__body').querySelector('.filter-value-list');
    if (!list) return;
    var showLabel = btn.querySelector('.filter-show-more__label').textContent;

    btn.addEventListener('click', function () {
      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      var hiddenItems = list.querySelectorAll('.filter-value-item--hidden');
      hiddenItems.forEach(function (item) {
        item.classList.toggle('is-visible', !isExpanded);
      });
      btn.setAttribute('aria-expanded', String(!isExpanded));
      var labelEl = btn.querySelector('.filter-show-more__label');
      if (isExpanded) {
        labelEl.textContent = showLabel;
      } else {
        labelEl.textContent = btn.dataset.lessText || 'Show less';
      }
    });
  });

  /* -- Price range slider (sidebar instance) -- */
  /* Portal panel sliders are bound inside bindPriceSlider() called after portal cloning */
  bindPriceSlider(document);

  /* -- Horizontal filter bar panels -- */
  var hbar = document.querySelector('.col-hbar');
  if (hbar) {
    var portalPanels = {};
    var hbarBtns     = [];

    /* -- initHbarPanels --
       Called on page load and after every AJAX filter update.
       Removes stale portal nodes, then clones fresh <template> elements
       into <body> so position:fixed is never clipped by ancestor overflow. */
    function initHbarPanels() {
      /* Remove previous portal nodes */
      Object.keys(portalPanels).forEach(function (k) {
        var n = portalPanels[k];
        if (n && n.parentNode) n.parentNode.removeChild(n);
      });
      portalPanels = {};

      hbarBtns = Array.from(hbar.querySelectorAll('.col-hbar__btn[aria-haspopup]'));

      hbar.querySelectorAll('template[id^="hbar-panel-tpl-"]').forEach(function (tpl) {
        var idx  = tpl.id.replace('hbar-panel-tpl-', '');
        var node = tpl.content.firstElementChild.cloneNode(true);
        document.body.appendChild(node);
        portalPanels[idx] = node;
        bindPriceSlider(node);

        var applyBtn = node.querySelector('[data-hbar-apply]');
        if (applyBtn) {
          applyBtn.addEventListener('click', function () { hbarNavigate(node); });
        }

        node.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
          cb.addEventListener('change', function () { hbarNavigate(node); });
        });
      });

      hbarBtns.forEach(function (btn) {
        var idx = btn.getAttribute('aria-controls').replace('hbar-panel-', '');
        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          closeAllHbarPanels(btn);
          var panel = portalPanels[idx];
          if (!panel) return;
          if (isOpen) {
            btn.setAttribute('aria-expanded', 'false');
            panel.classList.remove('is-open');
          } else {
            btn.setAttribute('aria-expanded', 'true');
            positionPanel(btn, panel);
            panel.classList.add('is-open');
          }
        });
      });
    }

    /* Sync sidebar form inputs from panel state, then trigger AJAX.
       Falls back to URL navigation if filter script hasn't loaded yet. */
    function hbarNavigate(panel) {
      closeAllHbarPanels(null);

      if (window.Marketly && window.Marketly.applyFilters && form) {
        /* -- AJAX path: update hidden sidebar form, then call applyFilters -- */
        var checkboxes = panel.querySelectorAll('input[type="checkbox"]');
        if (checkboxes.length > 0) {
          var filterName = checkboxes[0].name;
          /* Clear sidebar checkboxes for this filter param */
          form.querySelectorAll('input[type="checkbox"][name="' + filterName + '"]').forEach(function (cb) {
            cb.checked = false;
          });
          /* Mirror hbar panel selection into sidebar */
          checkboxes.forEach(function (hbarCb) {
            if (!hbarCb.checked || hbarCb.disabled) return;
            var sidebarCb = Array.from(
              form.querySelectorAll('input[type="checkbox"][name="' + filterName + '"]')
            ).find(function (cb) { return cb.value === hbarCb.value; });
            if (sidebarCb) sidebarCb.checked = true;
          });
        } else {
          /* Price range: mirror inputs */
          var minInput = panel.querySelector('[data-hbar-price-min]');
          var maxInput = panel.querySelector('[data-hbar-price-max]');
          if (minInput) {
            var sMin = form.querySelector('[name="' + minInput.name + '"]');
            if (sMin) sMin.value = minInput.value;
          }
          if (maxInput) {
            var sMax = form.querySelector('[name="' + maxInput.name + '"]');
            if (sMax) sMax.value = maxInput.value;
          }
        }
        window.Marketly.applyFilters();

      } else {
        /* -- Fallback: URL navigation (filter script not yet loaded) -- */
        var params = new URLSearchParams(window.location.search);
        params.delete('page');
        var cbs = panel.querySelectorAll('input[type="checkbox"]');
        if (cbs.length > 0) {
          var fname = cbs[0].name;
          params.delete(fname);
          cbs.forEach(function (cb) {
            if (cb.checked && !cb.disabled) params.append(fname, cb.value);
          });
        } else {
          var mIn = panel.querySelector('[data-hbar-price-min]');
          var mAx = panel.querySelector('[data-hbar-price-max]');
          if (mIn) { params.delete(mIn.name); if (mIn.value !== '') params.set(mIn.name, mIn.value); }
          if (mAx) { params.delete(mAx.name); if (mAx.value !== '') params.set(mAx.name, mAx.value); }
        }
        window.location.href = window.location.pathname + '?' + params.toString();
      }
    }

    function positionPanel(btn, panel) {
      var r      = btn.getBoundingClientRect();
      var panelW = panel.offsetWidth || 256;
      var top    = r.bottom + 8;
      var left   = r.left;
      if (left + panelW > window.innerWidth - 16) left = r.right - panelW;
      left = Math.max(8, left);
      panel.style.top  = top  + 'px';
      panel.style.left = left + 'px';
    }

    function closeAllHbarPanels(exceptBtn) {
      hbarBtns.forEach(function (btn) {
        if (btn === exceptBtn) return;
        btn.setAttribute('aria-expanded', 'false');
        var panel = portalPanels[btn.getAttribute('aria-controls').replace('hbar-panel-', '')];
        if (panel) panel.classList.remove('is-open');
      });
    }

    /* Close on outside click or Escape */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.col-hbar__item') && !e.target.closest('.col-hbar__panel')) {
        closeAllHbarPanels(null);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllHbarPanels(null);
    });
    window.addEventListener('resize', function () { closeAllHbarPanels(null); });

    /* After each AJAX filter, component-filter.js replaces .col-hbar__inner
       with fresh HTML (updated counts, active states) - re-init portal panels. */
    document.addEventListener('col:filtered', function () {
      closeAllHbarPanels(null);
      initHbarPanels();
    });

    initHbarPanels();
  }

  /* Helper: bind price range slider (called for sidebar and portal panels) */
  function bindPriceSlider(root) {
    root.querySelectorAll('[data-price-slider]').forEach(function (wrap) {
      /* Skip if already bound */
      if (wrap.dataset.sliderBound) return;
      wrap.dataset.sliderBound = '1';
      var minThumb  = wrap.querySelector('.price-range-thumb--min');
      var maxThumb  = wrap.querySelector('.price-range-thumb--max');
      var fill      = wrap.querySelector('.price-range-fill');
      var minLabel  = wrap.querySelector('[data-price-min-label]');
      var maxLabel  = wrap.querySelector('[data-price-max-label]');
      var priceWrap = wrap.closest('.price-range-wrap');
      var minInput  = priceWrap ? priceWrap.querySelector('#filter-price-min, #hbar-price-min, [data-hbar-price-min]') : null;
      var maxInput  = priceWrap ? priceWrap.querySelector('#filter-price-max, #hbar-price-max, [data-hbar-price-max]') : null;
      var symbol    = minLabel ? minLabel.textContent.replace(/[\d.]+/g, '').trim() : '';
      function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), hi); }
      function upd() {
        var lo = parseFloat(minThumb.min), hi = parseFloat(minThumb.max);
        var mn = parseFloat(minThumb.value), mx = parseFloat(maxThumb.value);
        fill.style.left  = ((mn - lo) / (hi - lo) * 100) + '%';
        fill.style.width = ((mx - mn) / (hi - lo) * 100) + '%';
        if (minLabel) minLabel.textContent = symbol + mn;
        if (maxLabel) maxLabel.textContent = symbol + mx;
      }
      minThumb.addEventListener('input', function () {
        minThumb.value = clamp(parseFloat(minThumb.value), parseFloat(minThumb.min), parseFloat(maxThumb.value) - 1);
        if (minInput) minInput.value = minThumb.value;
        upd();
      });
      maxThumb.addEventListener('input', function () {
        maxThumb.value = clamp(parseFloat(maxThumb.value), parseFloat(minThumb.value) + 1, parseFloat(maxThumb.max));
        if (maxInput) maxInput.value = maxThumb.value;
        upd();
      });
      minThumb.addEventListener('change', function () { if (minInput) minInput.dispatchEvent(new Event('change', { bubbles: true })); });
      maxThumb.addEventListener('change', function () { if (maxInput) maxInput.dispatchEvent(new Event('change', { bubbles: true })); });
      if (minInput) {
        minInput.addEventListener('change', function () {
          var v = clamp(parseFloat(minInput.value) || parseFloat(minThumb.min), parseFloat(minThumb.min), parseFloat(maxThumb.value) - 1);
          minInput.value = minThumb.value = v; upd();
        });
      }
      if (maxInput) {
        maxInput.addEventListener('change', function () {
          var v = clamp(parseFloat(maxInput.value) || parseFloat(maxThumb.max), parseFloat(minThumb.value) + 1, parseFloat(maxThumb.max));
          maxInput.value = maxThumb.value = v; upd();
        });
      }
      upd();
    });
  }

  /* -- Lazy-load filter JS -- */
  var page = document.querySelector('.col-page');
  if (page && page.dataset.filterJs) {
    var filterLoaded = false;
    var form = document.getElementById('collection-filters');

    function loadFilterJs(triggerEl) {
      if (filterLoaded) return;
      filterLoaded = true;
      var script = document.createElement('script');
      script.src = page.dataset.filterJs;

      /* After the script executes and binds its own listeners,
         replay the first interaction so it isn't lost. */
      script.addEventListener('load', function () {
        /* component-filter.js' rebind() has already run by this point.
           Find the interaction that triggered the load and re-dispatch it
           so applyFilters() picks up the current form state. */
        var pending = (triggerEl && triggerEl.type === 'checkbox')
          ? triggerEl
          : (form ? form.querySelector('.filter-value-cb:checked') : null);

        if (pending) {
          pending.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          /* Sort select triggered the load - replay that */
          var sortEl = document.querySelector('.col-sort-select');
          if (sortEl) sortEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      document.head.appendChild(script);
    }

    if (form) {
      /* Capture the specific element that triggered the load */
      form.addEventListener('change', function handler(e) {
        form.removeEventListener('change', handler);
        loadFilterJs(e.target);
      });
      var sortSelect = document.querySelector('.col-sort-select');
      if (sortSelect) {
        sortSelect.addEventListener('change', function handler() {
          sortSelect.removeEventListener('change', handler);
          loadFilterJs(sortSelect);
        });
      }
    }
  }

  /* -- Load more / Infinite scroll -- */
  var colResults = document.getElementById('col-results');
  if (!colResults) return;

  var loadingStyle = colResults.dataset.loadingStyle;
  if (loadingStyle !== 'load_more' && loadingStyle !== 'infinite') return;

  var isLoading = false;

  function fetchPage(url) {
    if (isLoading || !url) return;
    isLoading = true;

    var btn        = colResults.querySelector('[data-col-load-btn]');
    var sentinel   = colResults.querySelector('.col-sentinel');
    var loadMore   = colResults.querySelector('.col-load-more');

    if (btn) {
      btn.disabled = true;
      var label   = btn.querySelector('.col-load-more__label');
      var spinner = btn.querySelector('.col-load-more__spinner');
      if (label)   label.style.display   = 'none';
      if (spinner) spinner.style.display = 'flex';
    }

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('fetch failed');
        return r.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');

        /* Append new product cards */
        var newGrid     = doc.querySelector('.col-grid');
        var currentGrid = colResults.querySelector('.col-grid');
        if (newGrid && currentGrid) {
          Array.from(newGrid.children).forEach(function (child) {
            currentGrid.appendChild(child);
          });
        }

        /* Find next URL from fetched page */
        var nextEl  = doc.querySelector('[data-next-url]');
        var nextUrl = nextEl ? nextEl.dataset.nextUrl : '';

        if (loadMore)  loadMore.dataset.nextUrl  = nextUrl;
        if (sentinel)  sentinel.dataset.nextUrl  = nextUrl;

        /* Update or hide button */
        if (btn) {
          if (nextUrl) {
            btn.disabled = false;
            var label2   = btn.querySelector('.col-load-more__label');
            var spinner2 = btn.querySelector('.col-load-more__spinner');
            if (label2)   label2.style.display   = '';
            if (spinner2) spinner2.style.display = 'none';
          } else {
            if (loadMore) loadMore.hidden = true;
          }
        }

        /* Update sentinel spinner visibility. Inline style, not the `hidden`
           attribute: .col-sentinel__spinner has its own `display: flex` class
           rule, which beats the UA [hidden] rule in the cascade — the spinner
           would keep spinning forever even after the last page loads. */
        if (sentinel) {
          var spinnerEl = sentinel.querySelector('.col-sentinel__spinner');
          if (spinnerEl) spinnerEl.style.display = nextUrl ? 'flex' : 'none';
        }
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          var label3   = btn.querySelector('.col-load-more__label');
          var spinner3 = btn.querySelector('.col-load-more__spinner');
          if (label3)   label3.style.display   = '';
          if (spinner3) spinner3.style.display = 'none';
        }
      })
      .finally(function () {
        isLoading = false;
      });
  }

  if (loadingStyle === 'load_more') {
    colResults.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-col-load-btn]');
      if (!btn || btn.disabled) return;
      var wrap = colResults.querySelector('.col-load-more');
      var url  = wrap ? wrap.dataset.nextUrl : '';
      if (url) fetchPage(url);
    });
  }

  if (loadingStyle === 'infinite') {
    var sentinel = colResults.querySelector('.col-sentinel');
    if (sentinel && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var url = sentinel.dataset.nextUrl;
            if (url) {
              fetchPage(url);
            } else {
              observer.unobserve(sentinel);
            }
          }
        });
      }, { rootMargin: '300px' });
      observer.observe(sentinel);
    }
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.cl-track[data-slider="true"]').forEach(function (track) {
    var list    = track.querySelector('.cl-list');
    var btnPrev = track.querySelector('.cl-arrow--prev');
    var btnNext = track.querySelector('.cl-arrow--next');
    if (!list || !btnPrev || !btnNext) return;

    function getStep() {
      var card = list.querySelector('.cl-card');
      return card ? card.offsetWidth + 16 : 260;
    }

    function updateArrows() {
      var atStart = list.scrollLeft <= 4;
      var atEnd   = list.scrollLeft + list.offsetWidth >= list.scrollWidth - 4;
      btnPrev.classList.toggle('is-hidden', atStart);
      btnNext.classList.toggle('is-hidden', atEnd);
    }

    btnPrev.addEventListener('click', function () {
      list.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
    });

    btnNext.addEventListener('click', function () {
      list.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
    });

    list.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.faq-section').forEach(function (section) {
    section.querySelectorAll('.faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = this.closest('.faq-item');
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        this.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* -- Gallery -- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = Array.from(gallery.querySelectorAll('[data-slide]'));
    var thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    var navBtns = gallery.querySelectorAll('[data-nav]');
    var current = 0;

    function goTo(idx) {
      if (!slides.length) return;
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      slides[current].classList.remove('is-active');
      if (thumbs[current]) thumbs[current].classList.remove('is-active');
      current = idx;
      slides[current].classList.add('is-active');
      if (thumbs[current]) thumbs[current].classList.add('is-active');
    }

    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(current + parseInt(btn.dataset.nav, 10));
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.dataset.thumb, 10));
      });
    });

    var startX = 0;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
    });
  });

  /* -- Quantity steppers -- */
  document.querySelectorAll('.fp-section').forEach(function (section) {
    var qtyInput = section.querySelector('.fp-qty-input');
    if (!qtyInput) return;
    section.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.qty, 10);
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = next;
      });
    });
  });

  /* -- Description expand / collapse -- */
  document.querySelectorAll('[data-desc-toggle]').forEach(function (btn) {
    var wrap = btn.closest('.fp-desc-wrap');
    if (!wrap) return;
    var descEl = wrap.querySelector('[data-desc]');
    if (!descEl) return;

    /* hide toggle if content doesn't actually overflow */
    function checkOverflow() {
      if (descEl.scrollHeight <= descEl.clientHeight + 2) {
        btn.hidden = true;
      }
    }
    checkOverflow();
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(checkOverflow).observe(descEl);
    }

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        descEl.classList.add('fp-description--clamped');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = btn.dataset.readMore;
      } else {
        descEl.classList.remove('fp-description--clamped');
        btn.setAttribute('aria-expanded', 'true');
        btn.dataset.readMore = btn.dataset.readMore || btn.textContent;
        btn.textContent = btn.dataset.readLess;
      }
    });

    /* store translated strings from data attrs set below */
    btn.dataset.readLess = btn.dataset.readLess || btn.getAttribute('data-read-less') || 'Show less';
  });

  /* -- Variant selection + ATC -- */
  document.querySelectorAll('.fp-section').forEach(function (section) {
    var form = section.querySelector('form');
    if (!form) return;
    var variantIdInput = form.querySelector('[data-variant-id]');
    var jsonEl = section.querySelector('[data-variants-json]');

    if (variantIdInput && jsonEl) {
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = null; }

      if (variants) {
        function updateVariant() {
          var selectedValues = [];
          form.querySelectorAll('.fp-option-group').forEach(function (group) {
            var checked = group.querySelector('[data-variant-option]:checked');
            if (checked) selectedValues.push(checked.value);
          });

          var match = variants.find(function (v) {
            return v.options.length === selectedValues.length &&
              v.options.every(function (opt, i) { return opt === selectedValues[i]; });
          });

          if (!match) return;
          variantIdInput.value = match.id;

          var priceEl = section.querySelector('[data-price]');
          if (priceEl && window.Shopify && typeof Shopify.formatMoney === 'function') {
            var formatted = Shopify.formatMoney(match.price);
            var parts = formatted.replace(/[^0-9.,]/g, '').split('.');
            var intEl = priceEl.querySelector('.fp-price__integer');
            var centsEl = priceEl.querySelector('.fp-price__cents');
            if (intEl) intEl.textContent = parts[0];
            if (centsEl && parts[1]) centsEl.textContent = parts[1];
          }

          var atcBtn = form.querySelector('.fp-atc-btn');
          if (atcBtn) atcBtn.disabled = !match.available;
        }

        form.querySelectorAll('[data-variant-option]').forEach(function (inp) {
          inp.addEventListener('change', updateVariant);
        });
      }
    }

    var btn = form.querySelector('.fp-atc-btn');
    if (!btn) return;
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.classList.add('is-loading');
      var originalText = btn.textContent.trim();
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
          body: new URLSearchParams(new FormData(form))
        });
        if (res.ok) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = btn.dataset.addedLabel || originalText;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            btn.textContent = originalText;
            btn.classList.remove('is-added');
          }, 1800);
        } else {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 600);
        }
      } catch (err) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 600);
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MQ = window.matchMedia('(max-width: 47.9375em)');

  function setupAccordion() {
    document.querySelectorAll('.sf-block--link-list').forEach(function (block) {
      var btn = block.querySelector('.sf-nav__heading');
      if (!btn) return;

      function toggle() {
        var open = block.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      }

      function sync() {
        if (MQ.matches) {
          btn.setAttribute('role', 'button');
          btn.setAttribute('aria-expanded', block.classList.contains('is-open') ? 'true' : 'false');
          btn.style.cursor = '';
          btn.addEventListener('click', toggle);
        } else {
          btn.removeAttribute('role');
          btn.removeAttribute('aria-expanded');
          btn.style.cursor = 'default';
          btn.removeEventListener('click', toggle);
          block.classList.remove('is-open');
        }
      }

      if (MQ.addEventListener) {
        MQ.addEventListener('change', sync);
      } else {
        MQ.addListener(sync);
      }
      sync();
    });
  }

  function setupLocalization() {
    document.querySelectorAll('[data-sf-localization]').forEach(function (select) {
      select.addEventListener('change', function () {
        this.closest('form').submit();
      });
    });
  }

  function setupMarquee() {
    var track = document.querySelector('.sf-manifesto__track');
    var root  = document.querySelector('.sf-manifesto');
    if (!track || !root || !window.IntersectionObserver) return;
    new IntersectionObserver(function (entries) {
      track.style.animationPlayState = entries[0].isIntersecting ? 'running' : 'paused';
    }, { rootMargin: '100px' }).observe(root);
  }

  function setupNewsletter() {
    document.querySelectorAll('.sf-nl__form').forEach(function (form) {
      var btn = form.querySelector('.sf-nl__btn');
      if (!btn) return;
      form.addEventListener('submit', function () {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.style.opacity = '0.55';
      });
    });
  }

  function setup() {
    setupAccordion();
    setupLocalization();
    setupMarquee();
    setupNewsletter();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', setup)
    : setup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frequently-bought-together"]) return;
  try {
    
(function () {
  /* -- Section Rendering API fetch -- */
  var el = document.getElementById('fbt-placeholder');
  if (!el) return;
  fetch(
    '/recommendations/products?section_id=frequently-bought-together' +
    '&product_id=' + el.dataset.productId +
    '&intent=complementary' +
    '&limit=' + (el.dataset.limit || 4)
  )
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('.fbt-section');
      if (!content) return;
      var fallback = document.querySelector('[data-fbt-fallback]');
      if (fallback) {
        fallback.replaceWith(content);
      } else {
        el.replaceWith(content);
      }
      document.dispatchEvent(new CustomEvent('product-cards:injected', { detail: { root: content } }));
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    /* -- Predictive search - import on interaction -- */
    var psUrl = header.dataset.psUrl;
    if (psUrl) {
      var psLoaded = false;
      function loadPS() {
        if (psLoaded) return;
        psLoaded = true;
        var s   = document.createElement('script');
        s.src   = psUrl;
        s.defer = true;
        document.head.appendChild(s);
      }
      document.querySelectorAll(
        '.search-form__input, .mobile-search-form__input'
      ).forEach(function (inp) {
        inp.addEventListener('focus', loadPS, { once: true });
        inp.addEventListener('input', loadPS, { once: true });
      });
    }

    /* Publish header height + compensate fixed offset on #main-content */
    var _main = document.getElementById('main-content');
    var _shrTimer;

    function isStickyActive() {
      return window.innerWidth < 1024
        ? header.dataset.stickyMobile === 'true'
        : header.dataset.stickyDesktop === 'true';
    }

    function applyStuck(stuck) {
      var active = isStickyActive();
      header.classList.toggle('is-stuck', active && stuck);
      if (_main) {
        _main.style.paddingTop = (active && stuck) ? header.offsetHeight + 'px' : '';
      }
    }

    function syncHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
      if (_main && header.classList.contains('is-stuck')) {
        _main.style.paddingTop = header.offsetHeight + 'px';
      }
    }
    syncHeaderHeight();
    window.addEventListener('resize', function () {
      clearTimeout(_shrTimer);
      _shrTimer = setTimeout(function () {
        syncHeaderHeight();
        if (!isStickyActive()) {
          header.classList.remove('is-stuck');
          if (_main) _main.style.paddingTop = '';
        }
      }, 150);
    });

    /* Sticky: activate only after announcement bar scrolls out of view */
    var annBar = document.querySelector('.section-announcement-bar');
    if (annBar) {
      var stickyObs = new IntersectionObserver(function (entries) {
        applyStuck(!entries[0].isIntersecting);
      }, { threshold: 0 });
      stickyObs.observe(annBar);
    } else {
      applyStuck(true);
    }

    /* -- Departments panel toggle -- */
    var deptBtn   = header.querySelector('.site-header__dept-btn');
    var deptPanel = header.querySelector('.departments-panel');
    if (deptBtn && deptPanel) {
      deptBtn.addEventListener('click', function () {
        var open = deptBtn.getAttribute('aria-expanded') === 'true';
        deptBtn.setAttribute('aria-expanded', String(!open));
        deptPanel.hidden = open;
      });
      document.addEventListener('click', function (e) {
        if (!deptBtn.contains(e.target) && !deptPanel.contains(e.target)) {
          deptBtn.setAttribute('aria-expanded', 'false');
          deptPanel.hidden = true;
        }
      });
    }

    /* -- Locale (country/language) popover -- header-icons.liquid renders
       this once per header style (only one visible at a time via CSS), so
       loop over every instance rather than assuming a single element.
       References to btn/panel are captured once, up front, into a stable
       array — not re-looked-up via wrap.querySelector on every open/close
       — because the panel gets reparented straight onto <body> while
       open (see openLocaleInstance): a portal, so it always paints above
       the entire rest of the page regardless of which header style's
       ancestor chain it started in, with no z-index arms race against
       the nav row required. Re-querying through `wrap` after that move
       would fail, since the panel is no longer inside it. */
    var localeInstances = Array.prototype.slice.call(header.querySelectorAll('.site-header__locale'))
      .map(function (wrap) {
        return {
          btn: wrap.querySelector('.site-header__locale-btn'),
          panel: wrap.querySelector('.site-header__locale-panel'),
          home: wrap
        };
      })
      .filter(function (inst) { return inst.btn && inst.panel; });

    function closeLocaleInstance(inst) {
      clearTimeout(inst.hoverTimer);
      inst.btn.setAttribute('aria-expanded', 'false');
      inst.panel.hidden = true;
    }

    function openLocaleInstance(inst) {
      clearTimeout(inst.hoverTimer);
      document.body.appendChild(inst.panel);
      var rect = inst.btn.getBoundingClientRect();
      inst.panel.style.top = (rect.bottom + 8) + 'px';
      // Anchor the panel's right edge to the button's right edge without
      // ever needing to measure the panel's own width: translateX(-100%)
      // shifts it fully back by whatever width it ends up rendering at.
      inst.panel.style.left = rect.right + 'px';
      inst.panel.style.transform = 'translateX(-100%)';
      inst.panel.hidden = false;
      inst.btn.setAttribute('aria-expanded', 'true');
    }

    // Closes after a short delay rather than immediately, so moving the
    // mouse from the button down to the panel (now a sibling of it on
    // <body>, not a descendant — mouseleave on the button doesn't know
    // the panel is where the cursor is headed) doesn't close it out from
    // under the pointer. Hovering either one cancels the pending close.
    function scheduleLocaleClose(inst) {
      clearTimeout(inst.hoverTimer);
      inst.hoverTimer = setTimeout(function () { closeLocaleInstance(inst); }, 200);
    }

    localeInstances.forEach(function (inst) {
      inst.btn.addEventListener('click', function () {
        var open = inst.btn.getAttribute('aria-expanded') === 'true';
        if (open) closeLocaleInstance(inst); else openLocaleInstance(inst);
      });
      function onEscape(e) {
        if (e.key !== 'Escape') return;
        closeLocaleInstance(inst);
        inst.btn.focus();
      }
      inst.btn.addEventListener('keydown', onEscape);
      inst.panel.addEventListener('keydown', onEscape);

      // Desktop: hover opens/keeps it open. Touch devices don't fire
      // mouseenter from a tap, so this doesn't interfere with the click
      // behavior mobile relies on above.
      inst.btn.addEventListener('mouseenter', function () { openLocaleInstance(inst); });
      inst.btn.addEventListener('mouseleave', function () { scheduleLocaleClose(inst); });
      inst.panel.addEventListener('mouseenter', function () { clearTimeout(inst.hoverTimer); });
      inst.panel.addEventListener('mouseleave', function () { scheduleLocaleClose(inst); });
    });
    document.addEventListener('click', function (e) {
      localeInstances.forEach(function (inst) {
        if (inst.btn.contains(e.target) || inst.panel.contains(e.target)) return;
        closeLocaleInstance(inst);
      });
    });
    /* A scroll or resize invalidates the panel's computed position (it
       doesn't track the button), so just close it rather than let it
       drift away from the button that opened it. */
    window.addEventListener('scroll', function () {
      localeInstances.forEach(closeLocaleInstance);
    }, { passive: true });
    window.addEventListener('resize', function () {
      localeInstances.forEach(closeLocaleInstance);
    });

    /* -- Nav sub-dropdowns -- */
    header.querySelectorAll('.site-header__nav-dropdown').forEach(function (wrap) {
      var btn  = wrap.querySelector('.site-header__nav-link[aria-expanded]');
      var list = wrap.querySelector('.site-header__dropdown');
      if (!btn || !list) return;

      function openDrop()  { btn.setAttribute('aria-expanded', 'true');  list.classList.add('is-open'); }
      function closeDrop() { btn.setAttribute('aria-expanded', 'false'); list.classList.remove('is-open'); }

      wrap.addEventListener('mouseenter', openDrop);
      wrap.addEventListener('mouseleave', closeDrop);
      btn.addEventListener('click', function () {
        btn.getAttribute('aria-expanded') === 'true' ? closeDrop() : openDrop();
      });
      wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrop(); btn.focus(); } });
      wrap.addEventListener('focusout', function (e) {
        if (!wrap.contains(e.relatedTarget)) closeDrop();
      });
    });

    /* -- Mega menus - delayed hover so diagonal movement doesn't close the panel -- */
    header.querySelectorAll('.site-header__nav-item--mega').forEach(function (item) {
      var btn   = item.querySelector('.site-header__nav-link[aria-expanded]');
      var panel = item.querySelector('.site-header__mega');
      if (!btn || !panel) return;

      var megaTimer;

      function openMega() {
        clearTimeout(megaTimer);
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }

      function closeMega() {
        megaTimer = setTimeout(function () {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }, 150);
      }

      item.addEventListener('mouseenter', openMega);
      item.addEventListener('mouseleave', closeMega);

      btn.addEventListener('click', function () {
        item.classList.contains('is-open') ? closeMega() : openMega();
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { clearTimeout(megaTimer); item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) { clearTimeout(megaTimer); item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      });
    });

    /* -- Mobile nav -- */
    var mobileBtn   = header.querySelector('.site-header__mobile-btn');
    var mobileNav   = header.querySelector('.site-header__mobile-nav');
    var mobileClose = header.querySelector('.site-header__mobile-close');
    var overlay     = header.querySelector('.site-header__overlay');

    function openMobileNav() {
      mobileNav.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () { mobileNav.classList.add('is-open'); });
      mobileBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeMobileNav() {
      mobileNav.classList.remove('is-open');
      mobileBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () {
        mobileNav.hidden = true;
        overlay.hidden = true;
      }, 280);
    }

    if (mobileBtn && mobileNav) {
      mobileBtn.addEventListener('click', openMobileNav);
      if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
      if (overlay)     overlay.addEventListener('click', closeMobileNav);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMobileNav();
      });
    }

    /* -- Mobile nav accordion (sub-menus) -- */
    if (mobileNav) {
      mobileNav.addEventListener('click', function (e) {
        var toggleBtn = e.target.closest('.site-header__mobile-nav-link--parent');
        if (!toggleBtn) return;

        var item = toggleBtn.closest('.site-header__mobile-nav-item');
        var isOpen = item.classList.contains('is-open');

        mobileNav.querySelectorAll('.site-header__mobile-nav-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var btn = openItem.querySelector('.site-header__mobile-nav-link--parent');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          toggleBtn.setAttribute('aria-expanded', 'true');
        }
      });

      /* L2 groups toggle independently of the L1 accordion and of each
         other — several can stay open at once since each list is short. */
      mobileNav.addEventListener('click', function (e) {
        var subToggle = e.target.closest('.site-header__mobile-subnav-toggle');
        if (!subToggle) return;

        var group = subToggle.closest('.site-header__mobile-subnav-group');
        if (!group) return;

        var groupIsOpen = group.classList.contains('is-open');
        group.classList.toggle('is-open', !groupIsOpen);
        subToggle.setAttribute('aria-expanded', String(!groupIsOpen));
      });
    }

    /* -- Mobile search toggle -- */
    var searchToggle  = header.querySelector('.site-header__search-toggle');
    var mobileSearch  = header.querySelector('.site-header__mobile-search');
    var mobileInput   = mobileSearch && mobileSearch.querySelector('input[type="search"]');

    if (searchToggle && mobileSearch) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchToggle.getAttribute('aria-expanded') === 'true';
        searchToggle.setAttribute('aria-expanded', String(!isOpen));
        mobileSearch.hidden = isOpen;
        if (!isOpen && mobileInput) setTimeout(function () { mobileInput.focus(); }, 50);
      });
    }

    /* Mega menu quick-add */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mega-add]');
      if (!btn || btn.disabled) return;
      var variantId = parseInt(btn.dataset.megaAdd, 10);
      btn.disabled = true;
      btn.dataset.state = 'loading';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.dataset.state = 'added';
          if (window.MarketlyCart && window.MarketlyCart.refresh) window.MarketlyCart.refresh();
          setTimeout(function () { btn.dataset.state = ''; btn.disabled = false; }, 2000);
        })
        .catch(function () { btn.dataset.state = ''; btn.disabled = false; });
    });

    /* -- Centered header: inline expanding search --
       First click on the icon focuses the (CSS :focus-within) expanding field
       instead of submitting an empty search. A second click, or Enter, submits
       normally once there's something typed. */
    (function () {
      var csWrap = document.querySelector('.site-header__centered-search-inline');
      if (!csWrap) return;
      var csInput = csWrap.querySelector('.search-form__input');
      var csBtn   = csWrap.querySelector('.search-form__submit');
      if (!csInput || !csBtn) return;

      csBtn.addEventListener('click', function (e) {
        if (document.activeElement !== csInput && csInput.value === '') {
          e.preventDefault();
          csInput.focus();
        }
      });

      csInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          csInput.value = '';
          csInput.blur();
        }
      });
    })();

    /* -- Supermarket: browse panel - hover open + flyout sub-menus -- */
    (function () {
      var bWrap  = document.querySelector('[data-browse-wrap]');
      if (!bWrap) return;
      var bBtn   = bWrap.querySelector('.site-header__browse-btn');
      var bPanel = bWrap.querySelector('.site-header__browse-panel');
      if (!bBtn || !bPanel) return;

      var bTimer;

      function openBrowse() {
        clearTimeout(bTimer);
        bBtn.setAttribute('aria-expanded', 'true');
        bPanel.removeAttribute('hidden');
      }

      function closeBrowse() {
        bTimer = setTimeout(function () {
          bBtn.setAttribute('aria-expanded', 'false');
          bPanel.setAttribute('hidden', '');
          closeAllFlyouts();
        }, 120);
      }

      function closeAllFlyouts() {
        bPanel.querySelectorAll('.browse-panel__flyout').forEach(function (f) {
          f.setAttribute('hidden', '');
        });
        bPanel.querySelectorAll('[data-browse-trigger]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });
      }

      /* Hover opens/closes the browse panel */
      bWrap.addEventListener('mouseenter', openBrowse);
      bWrap.addEventListener('mouseleave', closeBrowse);

      /* Click keeps working for keyboard / touch */
      bBtn.addEventListener('click', function () {
        bBtn.getAttribute('aria-expanded') === 'true' ? closeBrowse() : openBrowse();
      });

      /* Hovering a list item with data-browse-trigger shows its flyout */
      bPanel.addEventListener('mouseover', function (e) {
        var trigger = e.target.closest('[data-browse-trigger]');
        if (!trigger) return;
        clearTimeout(bTimer);
        var id = trigger.dataset.browseTrigger;
        closeAllFlyouts();
        var flyout = document.getElementById(id);
        if (flyout) {
          flyout.removeAttribute('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      /* Outside click closes panel */
      document.addEventListener('click', function (e) {
        if (!bWrap.contains(e.target)) {
          bBtn.setAttribute('aria-expanded', 'false');
          bPanel.setAttribute('hidden', '');
          closeAllFlyouts();
        }
      });
    })();

    /* -- Priority+ navigation: shared factory for standard + compact -- */
    function initPriorityNav(navEl) {
      var navList  = navEl && navEl.querySelector('.site-header__nav-list');
      var moreWrap = navEl && navEl.querySelector('.site-header__nav-more');
      var moreBtn  = moreWrap && moreWrap.querySelector('.site-header__nav-more-btn');
      var moreList = moreWrap && moreWrap.querySelector('.site-header__nav-more-list');
      if (!navEl || !navList || !moreWrap || !moreBtn || !moreList) return;

      var moreItems = Array.from(moreList.querySelectorAll('li'));
      var ready = false;
      function showEl(el, v) { el.style.display = v || 'flex'; }
      function hideEl(el) { el.style.display = 'none'; }

      function updateNav() {
        var navW = navEl.offsetWidth;
        if (!navW) return;
        var items = Array.from(navList.children);
        items.forEach(function (item) { showEl(item, 'flex'); });
        hideEl(moreWrap);
        var widths = items.map(function (item) { return item.offsetWidth; });
        var totalW = widths.reduce(function (s, w) { return s + w; }, 0);
        if (totalW <= navW + 2) { moreItems.forEach(function (li) { hideEl(li); }); }
        else {
          showEl(moreWrap, 'flex');
          var availW = navW - moreWrap.offsetWidth;
          var used = 0, overflowFrom = items.length;
          for (var i = 0; i < items.length; i++) {
            used += widths[i];
            if (used > availW + 2) { overflowFrom = i; break; }
          }
          items.forEach(function (item, i) { i >= overflowFrom ? hideEl(item) : showEl(item, 'flex'); });
          moreItems.forEach(function (li, idx) { idx >= overflowFrom ? showEl(li, 'block') : hideEl(li); });
        }
        /* Mark as ready on first successful measurement — reveals nav (visibility:hidden → visible) */
        if (!ready) { ready = true; navEl.classList.add('is-nav-ready'); }
      }

      moreBtn.addEventListener('click', function () {
        var expanded = moreBtn.getAttribute('aria-expanded') === 'true';
        moreBtn.setAttribute('aria-expanded', String(!expanded));
        moreList.classList.toggle('is-open', !expanded);
      });
      document.addEventListener('click', function (e) {
        if (!moreWrap.contains(e.target)) {
          moreBtn.setAttribute('aria-expanded', 'false');
          moreList.classList.remove('is-open');
        }
      });

      updateNav();
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(updateNav); }
      setTimeout(updateNav, 300);
      if (window.ResizeObserver) {
        new ResizeObserver(updateNav).observe(navEl);
      } else {
        window.addEventListener('resize', updateNav);
      }
    }

    function initAllPriorityNavs(root) {
      var standardNav = root.querySelector('.site-header__nav-bar .site-header__nav');
      if (standardNav) initPriorityNav(standardNav);
      var compactNav = root.querySelector('.site-header__compact .site-header__compact-nav');
      if (compactNav) initPriorityNav(compactNav);
      var centeredNav = root.querySelector('.site-header__centered .site-header__centered-nav');
      if (centeredNav) initPriorityNav(centeredNav);
    }

    initAllPriorityNavs(header);

    /* Re-init priority navs when header section re-renders in the theme editor */
    document.addEventListener('shopify:section:load', function (e) {
      var newHeader = e.target.querySelector('.site-header');
      if (newHeader) initAllPriorityNavs(newHeader);
    });


  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
var sliders = document.querySelectorAll('.hero-slider');
sliders.forEach(function(slider) {
  if (slider.dataset.hsInit) return;
  slider.dataset.hsInit = '1';

  var slides = Array.from(slider.querySelectorAll('.hero-slider__slide'));
  var dots   = Array.from(slider.querySelectorAll('.hero-slider__dot'));
  var prev   = slider.querySelector('.hero-slider__arrow--prev');
  var next   = slider.querySelector('.hero-slider__arrow--next');
  var count  = slides.length;
  if (count <= 1) return;

  var current  = 0;
  var autoplay = slider.dataset.autoplay === 'true';
  var speed    = (parseInt(slider.dataset.speed, 10) || 5) * 1000;
  var timer    = null;

  // Mark inactive slides as aria-hidden on init
  slides.forEach(function(slide, i) {
    if (i !== 0) slide.setAttribute('aria-hidden', 'true');
  });

  function goTo(index) {
    var prev_idx = current;
    current = (index + count) % count;
    if (prev_idx === current) return;

    slides[prev_idx].classList.remove('is-active');
    slides[prev_idx].setAttribute('aria-hidden', 'true');

    slides[current].classList.add('is-active');
    slides[current].removeAttribute('aria-hidden');

    if (dots[prev_idx]) {
      dots[prev_idx].classList.remove('is-active');
      dots[prev_idx].setAttribute('aria-current', 'false');
    }
    if (dots[current]) {
      dots[current].classList.add('is-active');
      dots[current].setAttribute('aria-current', 'true');
    }
  }

  function stop() {
    clearInterval(timer);
    timer = null;
  }

  function start() {
    if (!autoplay) return;
    stop();
    timer = setInterval(function() { goTo(current + 1); }, speed);
  }

  function resetTimer() { stop(); start(); }

  if (prev) prev.addEventListener('click', function() { goTo(current - 1); resetTimer(); });
  if (next) next.addEventListener('click', function() { goTo(current + 1); resetTimer(); });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      goTo(parseInt(dot.dataset.index, 10));
      resetTimer();
    });
  });

  // Touch/swipe
  var tx = 0, ty = 0;
  slider.addEventListener('touchstart', function(e) {
    tx = e.touches[0].clientX;
    ty = e.touches[0].clientY;
  }, { passive: true });
  slider.addEventListener('touchend', function(e) {
    var dx = tx - e.changedTouches[0].clientX;
    var dy = ty - e.changedTouches[0].clientY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 44) {
      goTo(dx > 0 ? current + 1 : current - 1);
      resetTimer();
    }
  });

  // Pause on hover / focus / hidden tab
  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);
  slider.addEventListener('focusin',    stop);
  slider.addEventListener('focusout',   start);
  document.addEventListener('visibilitychange', function() {
    document.hidden ? stop() : start();
  });

  start();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function () {
  /* -- Add address toggle ------------------------------- */
  var addTrigger = document.getElementById('cad-add-trigger');
  var emptyTrigger = document.getElementById('cad-empty-trigger');
  var addCancel = document.getElementById('cad-add-cancel');
  var newForm = document.getElementById('cad-new-form');

  function openNewForm() {
    if (!newForm) return;
    newForm.classList.add('is-open');
    newForm.setAttribute('aria-hidden', 'false');
    if (addTrigger) addTrigger.setAttribute('aria-expanded', 'true');
    newForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function closeNewForm() {
    if (!newForm) return;
    newForm.classList.remove('is-open');
    newForm.setAttribute('aria-hidden', 'true');
    if (addTrigger) addTrigger.setAttribute('aria-expanded', 'false');
  }

  if (addTrigger) addTrigger.addEventListener('click', openNewForm);
  if (emptyTrigger) emptyTrigger.addEventListener('click', openNewForm);
  if (addCancel) addCancel.addEventListener('click', closeNewForm);

  /* -- Edit address toggles ----------------------------- */
  var editBtns = document.querySelectorAll('.cad-card__action-btn--edit');
  editBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.id;
      var panel = document.getElementById('cad-edit-' + id);
      if (!panel) return;
      var isOpen = panel.classList.contains('is-open');
      panel.classList.toggle('is-open', !isOpen);
      panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  var closeBtns = document.querySelectorAll('[data-cad-close]');
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.cadClose;
      var panel = document.getElementById('cad-edit-' + id);
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      var editBtn = document.querySelector('[data-id="' + id + '"]');
      if (editBtn) editBtn.setAttribute('aria-expanded', 'false');
    });
  });

  /* -- Delete confirmation ------------------------------ */
  var deleteBtns = document.querySelectorAll('.cad-card__action-btn--delete');
  deleteBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var msg = btn.dataset.confirm;
      if (msg && !window.confirm(msg)) {
        e.preventDefault();
      }
    });
  });

  /* -- Country / province selectors ---------------------
     all_country_option_tags puts a JSON-encoded [name, code] array of
     subregions on each <option data-provinces>. Without this, the
     province <select> stays stuck on its single placeholder option and
     customers in countries that require a state/province (US, CA, AU...)
     can't save a valid address at all. One country <select> per address
     form (new + one per saved address), so this runs once per instance. */
  function initCountrySelector(countrySelect) {
    var suffix = countrySelect.id.replace('cad-ct-', '');
    var provinceSelect = document.getElementById('cad-pv-' + suffix);
    var provinceWrap = document.getElementById('cad-prov-wrap-' + suffix);
    if (!provinceSelect) return;

    function populateProvinces() {
      var selected = countrySelect.options[countrySelect.selectedIndex];
      var provinces = [];
      if (selected) {
        var raw = selected.getAttribute('data-provinces');
        if (raw) {
          try { provinces = JSON.parse(raw); } catch (e) { provinces = []; }
        }
      }

      var defaultProvince = provinceSelect.dataset.default || '';
      provinceSelect.innerHTML = '';

      if (!provinces.length) {
        if (provinceWrap) provinceWrap.hidden = true;
        return;
      }
      if (provinceWrap) provinceWrap.hidden = false;

      provinces.forEach(function (pair) {
        var opt = document.createElement('option');
        opt.value = pair[1];
        opt.textContent = pair[0];
        if (pair[1] === defaultProvince) opt.selected = true;
        provinceSelect.appendChild(opt);
      });
    }

    var defaultCountry = countrySelect.dataset.default;
    if (defaultCountry) {
      for (var i = 0; i < countrySelect.options.length; i++) {
        if (countrySelect.options[i].value === defaultCountry) {
          countrySelect.selectedIndex = i;
          break;
        }
      }
    }

    populateProvinces();
    countrySelect.addEventListener('change', populateProvinces);
  }

  document.querySelectorAll('select[name="address[country]"]').forEach(initCountrySelector);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    var loginView    = document.getElementById('ca-login-view');
    var recoverView  = document.getElementById('ca-recover-view');
    var forgotLink   = document.getElementById('ca-forgot-link');
    var cancelBtn    = document.getElementById('ca-recover-cancel');
    if (!loginView || !recoverView) return;

    function showRecover() {
      loginView.hidden = true;
      recoverView.hidden = false;
      history.replaceState(null, '', '#recover');
    }
    function showLogin() {
      recoverView.hidden = true;
      loginView.hidden = false;
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    if (forgotLink) forgotLink.addEventListener('click', showRecover);
    if (cancelBtn)  cancelBtn.addEventListener('click', showLogin);

    // Direct link / bookmark to #recover, or a fresh page load where the
    // recover form wasn't just submitted (server-rendered `hidden` above
    // only accounts for the just-submitted case).
    if (window.location.hash === '#recover') showRecover();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
var npModal      = document.getElementById('np-modal');
var npSectionId  = npModal && npModal.dataset.sectionId;
var npOpen       = false;
var npInEditor   = window.Shopify && window.Shopify.designMode;

if (npModal) {
  var npDelay = (parseInt(npModal.dataset.delay, 10) || 5) * 1000;
  var npFreq  = npModal.dataset.frequency || 'once';
  var npDays  = parseInt(npModal.dataset.cookieDays, 10) || 30;
  var NP_KEY  = 'mkly_np';

  function npGetCookie(n) {
    var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function npSetCookie(n, v, d) {
    var exp = new Date(Date.now() + d * 864e5).toUTCString();
    document.cookie = n + '=' + encodeURIComponent(v) + '; expires=' + exp + '; path=/; SameSite=Lax';
  }
  function npShouldShow() {
    if (npFreq === 'always') return true;
    var stored = npGetCookie(NP_KEY);
    if (!stored) return true;
    if (npFreq === 'once_per_day') return (Date.now() - parseInt(stored, 10)) > 864e5;
    return false;
  }
  function npLock() {
    if (document.body.style.position === 'fixed') return;
    var y = window.scrollY;
    document.body.dataset.npScrollY = y;
    document.body.dataset.npOwnsLock = '1';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + y + 'px';
    document.body.style.width = '100%';
  }
  function npUnlock() {
    if (document.body.dataset.npOwnsLock !== '1') return;
    var y = parseInt(document.body.dataset.npScrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    delete document.body.dataset.npOwnsLock;
    window.scrollTo(0, y);
  }
  function npOpenModal() {
    if (npOpen || !npModal) return;
    npOpen = true;
    npModal.hidden = false;
    if (!npInEditor) npLock();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { npModal.classList.add('is-open'); });
    });
    if (!npInEditor) {
      var emailInput = npModal.querySelector('.np-input');
      if (emailInput) setTimeout(function () { emailInput.focus({ preventScroll: true }); }, 360);
    }
  }
  function npCloseModal(skipCookie) {
    if (!npOpen || !npModal) return;
    npOpen = false;
    npModal.classList.remove('is-open');
    if (!npInEditor) npUnlock();
    npModal.addEventListener('transitionend', function handler() {
      npModal.removeEventListener('transitionend', handler);
      if (npModal) npModal.hidden = true;
    }, { once: true });
    if (!skipCookie && !npInEditor && npFreq !== 'always') {
      npSetCookie(NP_KEY, npFreq === 'once_per_day' ? String(Date.now()) : '1', npDays);
    }
  }
  function npShowSuccess() {
    var formWrap = npModal && npModal.querySelector('.np-form-wrap');
    var noteEl   = npModal && npModal.querySelector('.np-note');
    if (formWrap) {
      formWrap.innerHTML =
        '<p class="np-success" role="status">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M6 10L8.5 12.5L14 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        (npModal.dataset.i18nSuccess || 'Thank you for subscribing!') +
        '</p>';
    }
    if (noteEl) noteEl.style.display = 'none';
    npSetCookie(NP_KEY, '1', npDays);
    setTimeout(function () { npCloseModal(true); }, 2600);
  }

  /* -- Delegated: click to close -- */
  document.addEventListener('click', function (e) {
    if (!npOpen) return;
    if (e.target.closest('[data-np-close]')) npCloseModal(false);
  });

  /* -- Escape -- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && npOpen) npCloseModal(false);
  });

  /* -- Focus trap -- */
  var NP_FOCUSABLE = 'button:not([disabled]),[href],input,[tabindex]:not([tabindex="-1"])';
  document.addEventListener('keydown', function (e) {
    if (!npOpen || e.key !== 'Tab' || !npModal) return;
    var els = Array.from(npModal.querySelectorAll(NP_FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* -- Delegated: AJAX form submit -- */
  document.addEventListener('submit', function (e) {
    if (!e.target || e.target.id !== 'newsletter-popup-form') return;
    e.preventDefault();
    if (npInEditor) return;
    var form   = e.target;
    var emailEl = form.querySelector('[name="contact[email]"]');
    if (!emailEl || !emailEl.validity.valid) return;
    var btn = form.querySelector('.np-submit');
    if (btn) btn.disabled = true;
    fetch(form.action, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new URLSearchParams(new FormData(form)).toString()
    })
    .then(function () { npShowSuccess(); })
    .catch(function () { if (btn) btn.disabled = false; });
  });

  /* -- Theme editor events -- */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.detail.sectionId !== npSectionId) return;
    npModal = document.getElementById('np-modal');
    if (!npModal) return;
    npOpen = false;
    npOpenModal();
  });

  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.detail.sectionId !== npSectionId) return;
    npCloseModal(true);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail.sectionId !== npSectionId) return;
    npModal = document.getElementById('np-modal');
    npOpen  = false;
    if (npModal && npInEditor) npOpenModal();
  });

  /* -- Initial trigger -- */
  if (npInEditor) {
    npOpenModal();
  } else if (npShouldShow()) {
    setTimeout(npOpenModal, npDelay);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
(function () {
  /* -- Section Rendering API fetch -- */
  var el = document.getElementById('pdr-placeholder');
  if (!el) return;
  fetch(
    '/recommendations/products?section_id=product-recommendations' +
    '&product_id=' + el.dataset.productId +
    '&intent=related&limit=10'
  )
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('.pdr-section');
      if (!content) return;
      var fallback = document.querySelector('[data-pdr-fallback]');
      if (fallback) {
        fallback.replaceWith(content);
      } else {
        el.replaceWith(content);
      }
      document.dispatchEvent(new CustomEvent('product-cards:injected', { detail: { root: content } }));
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"]) return;
  try {
    
(function () {
  var nav = document.querySelector('.pdt-nav');
  if (nav) {
    nav.querySelectorAll('.pdt-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('aria-controls');
        nav.querySelectorAll('.pdt-tab').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        document.querySelectorAll('.pdt-panel').forEach(function (p) {
          p.classList.remove('is-active');
          p.hidden = true;
        });
        var panel = document.getElementById(targetId);
        if (panel) { panel.classList.add('is-active'); panel.hidden = false; }
      });
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var page = document.querySelector('.pd-page');
  if (!page) return;

  // -- Data --
  var variantsEl = document.getElementById('pd-variants-json');
  var mediaEl = document.getElementById('pd-media-json');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var mediaList = mediaEl ? JSON.parse(mediaEl.textContent) : [];
  var moneyFormat = page.dataset.moneyFormat || '';

  // -- State --
  var selectedOptions = {};
  var form = document.getElementById('pd-form');

  if (form) {
    form.querySelectorAll('.pd-pill__radio').forEach(function (r) {
      if (r.checked) selectedOptions[r.dataset.optionPosition] = r.value;
    });
  }

  // -- Money format --
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var noTrailing = parseFloat(amount).toString();
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_trailing_zeros\s*\}\}/g, noTrailing)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  }

  // -- Variant matching --
  function findVariant() {
    return variants.find(function (v) {
      if (selectedOptions['1'] && v.option1 !== selectedOptions['1']) return false;
      if (selectedOptions['2'] && v.option2 !== selectedOptions['2']) return false;
      if (selectedOptions['3'] && v.option3 !== selectedOptions['3']) return false;
      return true;
    });
  }

  // -- Update price display --
  function updatePrice(variant) {
    var priceEl = document.getElementById('pd-price');
    var compareEl = document.getElementById('pd-compare-price');
    var saleEl = document.getElementById('pd-sale-badge');
    var unitEl = document.getElementById('pd-unit-price');
    if (!priceEl) return;

    var hasSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    priceEl.textContent = formatMoney(variant.price);
    priceEl.classList.toggle('pd-price--sale', hasSale);

    if (compareEl) {
      compareEl.hidden = !hasSale;
      if (hasSale) compareEl.textContent = formatMoney(variant.compare_at_price);
    }

    if (saleEl) {
      saleEl.hidden = !hasSale;
      if (hasSale) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        saleEl.textContent = '-' + pct + '%';
      }
    }

    if (unitEl) {
      if (variant.unit_price) {
        var parts = [formatMoney(variant.unit_price)];
        if (variant.unit_price_ref_value && variant.unit_price_ref_value !== 1) {
          parts.push('/ ' + variant.unit_price_ref_value);
        }
        if (variant.unit_price_ref_unit) parts.push(variant.unit_price_ref_unit);
        unitEl.textContent = parts.join(' ');
        unitEl.hidden = false;
      } else {
        unitEl.hidden = true;
      }
    }
  }

  // -- Update variant subtitle --
  function updateVariantSubtitle(variant) {
    var el = document.getElementById('pd-variant-subtitle');
    if (!el) return;
    if (variant && variant.option1 && variant.option1 !== 'Default Title') {
      el.textContent = variant.option1;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  // -- Update ATC button --
  function updateAtc(variant) {
    var btn = document.getElementById('pd-atc');
    var text = document.getElementById('pd-atc-text');
    if (!btn) return;
    var available = variant && variant.available;
    btn.disabled = !available;
    if (text) {
      text.textContent = available
        ? (btn.dataset.textAdd || '')
        : (btn.dataset.textSoldOut || '');
    }
  }

  // -- Update SKU --
  function updateSku(variant) {
    var skuEl = document.getElementById('pd-sku');
    var skuVal = document.getElementById('pd-sku-value');
    if (!skuEl) return;
    if (variant && variant.sku) {
      if (skuVal) skuVal.textContent = variant.sku;
      skuEl.hidden = false;
    } else {
      skuEl.hidden = true;
    }
  }

  // -- Update URL --
  function updateUrl(variant) {
    if (!variant) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', String(variant.id));
    history.replaceState({}, '', url.toString());
  }

  // -- Update gallery via custom event --
  function updateGallery(variant) {
    if (!variant || !variant.featured_media_id) return;
    var item = mediaList.find(function (m) { return m.id === variant.featured_media_id; });
    if (!item) return;
    document.dispatchEvent(new CustomEvent('pd:variant-change', { detail: { mediaIndex: item.index } }));
  }

  var CHECK_SVG = '<svg class="pd-pill__check" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

  // -- Sync pill + swatch + dropdown selected states --
  function syncControls() {
    if (!form) return;
    form.querySelectorAll('.pd-pill').forEach(function (pill) {
      var radio = pill.querySelector('.pd-pill__radio');
      var face = pill.querySelector('.pd-pill__face');
      var selected = radio && radio.checked;
      pill.classList.toggle('is-selected', selected);
      if (face) {
        var existing = face.querySelector('.pd-pill__check');
        if (selected && !existing) {
          face.insertAdjacentHTML('afterbegin', CHECK_SVG);
        } else if (!selected && existing) {
          existing.remove();
        }
      }
    });
    form.querySelectorAll('.pd-swatch').forEach(function (swatch) {
      var radio = swatch.querySelector('.pd-pill__radio');
      swatch.classList.toggle('is-selected', radio && radio.checked);
    });
    form.querySelectorAll('[data-option-selected]').forEach(function (el) {
      var pos = el.dataset.optionSelected;
      if (selectedOptions[pos]) el.textContent = selectedOptions[pos];
    });
  }

  // -- On variant change --
  function onVariantChange() {
    syncControls();
    var variant = findVariant();
    if (!variant) return;
    var idInput = form && form.querySelector('[data-variant-id]');
    if (idInput) idInput.value = variant.id;
    updatePrice(variant);
    updateVariantSubtitle(variant);
    updateSku(variant);
    updateAtc(variant);
    updateUrl(variant);
    updateGallery(variant);
    document.dispatchEvent(new CustomEvent('pd:pickup-update', { detail: { variantId: variant.id } }));
  }

  // -- Bind option controls (pills + dropdowns) --
  if (form) {
    form.querySelectorAll('.pd-pill__radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        selectedOptions[radio.dataset.optionPosition] = radio.value;
        onVariantChange();
      });
    });

    form.querySelectorAll('.pd-option__select').forEach(function (select) {
      selectedOptions[select.dataset.optionPosition] = select.value;
      select.addEventListener('change', function () {
        selectedOptions[select.dataset.optionPosition] = select.value;
        onVariantChange();
      });
    });

    // -- Selling plan selector --
    var spInput = document.getElementById('pd-selling-plan');
    if (spInput) {
      form.querySelectorAll('[data-sp-input]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          spInput.value = radio.value;
        });
      });
    }

    // -- Gift card recipient toggle --
    var recipientToggle = form.querySelector('[data-recipient-toggle]');
    var recipientFields = document.getElementById('pd-recipient-fields');
    if (recipientToggle && recipientFields) {
      recipientToggle.addEventListener('change', function () {
        recipientFields.hidden = !recipientToggle.checked;
        var inputs = recipientFields.querySelectorAll('input, textarea');
        inputs.forEach(function (el) { el.disabled = !recipientToggle.checked; });
      });
      var inputs = recipientFields.querySelectorAll('input, textarea');
      inputs.forEach(function (el) { el.disabled = true; });
    }

    // -- Qty stepper --
    var qtyInput = form.querySelector('.pd-qty__input');
    if (qtyInput) {
      var minusBtn = form.querySelector('[data-qty-minus]');
      var plusBtn = form.querySelector('[data-qty-plus]');
      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10);
          if (v > 1) qtyInput.value = v - 1;
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          qtyInput.value = parseInt(qtyInput.value, 10) + 1;
        });
      }
    }
  }

  // -- Gallery navigation --
  var galleryStage = document.getElementById('pd-gallery-stage');
  var currentSlide = 0;

  function goToSlide(index) {
    var slides = galleryStage ? galleryStage.querySelectorAll('[data-gallery-slide]') : [];
    var thumbBtns = document.querySelectorAll('[data-gallery-thumb]');
    var dots = document.querySelectorAll('[data-gallery-dot]');
    var total = slides.length;
    if (!total) return;
    currentSlide = ((index % total) + total) % total;
    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === currentSlide);
      s.setAttribute('aria-hidden', i === currentSlide ? 'false' : 'true');
    });
    thumbBtns.forEach(function (t) {
      var ti = parseInt(t.dataset.galleryThumb, 10);
      t.classList.toggle('is-active', ti === currentSlide);
      t.setAttribute('aria-selected', ti === currentSlide ? 'true' : 'false');
    });
    dots.forEach(function (d) {
      d.classList.toggle('is-active', parseInt(d.dataset.galleryDot, 10) === currentSlide);
    });
  }

  // Listen for variant-triggered gallery update
  document.addEventListener('pd:variant-change', function (e) {
    goToSlide(e.detail.mediaIndex);
  });

  // Prev / next arrows
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentSlide - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentSlide + 1); });

  // Dot navigation
  document.querySelectorAll('[data-gallery-dot]').forEach(function (dot) {
    dot.addEventListener('click', function () { goToSlide(parseInt(dot.dataset.galleryDot, 10)); });
  });

  // Thumbnail click
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () { goToSlide(parseInt(thumb.dataset.galleryThumb, 10)); });
  });

  // -- Touch/swipe for mobile --
  if (galleryStage) {
    var touchStartX = 0;
    var touchStartY = 0;
    galleryStage.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    galleryStage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goToSlide(dx < 0 ? currentSlide + 1 : currentSlide - 1);
      }
    }, { passive: true });
  }

  // -- Thumbs more button (scroll thumbnails) --
  var thumbsMoreBtn = document.querySelector('.pd-gallery__thumbs-more');
  var thumbsContainer = document.querySelector('.pd-gallery__thumbs');
  if (thumbsMoreBtn && thumbsContainer) {
    thumbsMoreBtn.addEventListener('click', function () {
      thumbsContainer.scrollBy({ top: 144, behavior: 'smooth' });
    });
  }

  // -- Snippet description -> scroll to Description tab --
  var snippetLink = document.querySelector('[data-scroll-to-desc]');
  if (snippetLink) {
    snippetLink.addEventListener('click', function (e) {
      e.preventDefault();
      var tabBtn = document.querySelector('[data-tab-type="description"]');
      if (tabBtn) tabBtn.click();
      var panelId = tabBtn && tabBtn.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      setTimeout(function () {
        var target = panel || tabBtn;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    });
  }

  // -- Cart error display --
  var cartErrorEl = document.getElementById('pd-cart-error');
  if (cartErrorEl && form) {
    document.addEventListener('cart:add-error', function (e) {
      if (e.detail && e.detail.form !== form) return;
      var msg = (e.detail && e.detail.message) || cartErrorEl.dataset.errorMsg || '';
      cartErrorEl.textContent = msg;
      cartErrorEl.hidden = false;
    });
    form.addEventListener('submit', function () {
      cartErrorEl.hidden = true;
      cartErrorEl.textContent = '';
    });
  }

  // -- Load gallery JS --
  if (page.dataset.galleryJs) {
    var script = document.createElement('script');
    script.src = page.dataset.galleryJs;
    script.defer = true;
    document.head.appendChild(script);
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-to-basket"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.recipe-basket__card').forEach(function (card) {
    var section     = card.closest('[data-section-id]');
    var addAllBtn   = card.querySelector('.recipe-basket__add-all');
    var btnTotal    = card.querySelector('.recipe-basket__btn-total');
    var servesCount = card.querySelector('.recipe-basket__serves-count');
    var serveBtns   = card.querySelectorAll('.recipe-basket__serves-btn');
    var cards       = card.querySelectorAll('.ingredient-card[data-variant-id]');

    if (!addAllBtn || !servesCount) return;

    var baseServes = parseInt(servesCount.dataset.serves) || 2;
    var baseTotal  = parseInt(addAllBtn.dataset.baseTotal) || 0;
    var currentServes = baseServes;

    function updateUI() {
      servesCount.textContent = currentServes;

      var ratio = currentServes / baseServes;

      cards.forEach(function (c) {
        var basePrice   = parseInt(c.dataset.basePrice) || 0;
        var priceEl     = c.querySelector('[data-display-price]');
        if (priceEl && basePrice) {
          var newPrice = Math.round(basePrice * ratio);
          priceEl.textContent = formatMoney(newPrice);
        }
      });

      if (btnTotal) {
        var newTotal = Math.round(baseTotal * ratio);
        btnTotal.textContent = formatMoney(newTotal);
      }
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      return (cents / 100).toFixed(2);
    }

    serveBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.dataset.dir);
        var next = currentServes + dir;
        if (next < 1) return;
        currentServes = next;
        updateUI();
      });
    });

    addAllBtn.addEventListener('click', async function () {
      var items = [];
      cards.forEach(function (c) {
        var vid     = parseInt(c.dataset.variantId);
        var baseQty = parseFloat(c.dataset.baseQty) || 1;
        var qty     = Math.max(1, Math.round(baseQty * currentServes / baseServes));
        if (vid) items.push({ id: vid, quantity: qty });
      });
      if (!items.length) return;

      addAllBtn.disabled = true;
      var orig = addAllBtn.innerHTML;
      addAllBtn.textContent = 'Adding…';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        });
        if (res.ok) {
          addAllBtn.textContent = '✓ Added to basket!';
          if (window.MarketlyCart && window.MarketlyCart.refresh) {
            window.MarketlyCart.refresh().then(function () {
              var drawerEl = document.querySelector('[data-cart-drawer]');
              var cType = drawerEl ? (drawerEl.dataset.cartType || 'drawer') : 'drawer';
              var autoOpen = !drawerEl || drawerEl.dataset.cartAutoOpen !== 'false';
              if (cType === 'page' && autoOpen) {
                window.location.href = '/cart';
              } else if (window.MarketlyCart.openDrawer) {
                window.MarketlyCart.openDrawer();
              }
            });
          } else {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (c) {
                document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                  el.textContent = c.item_count;
                  el.classList.toggle('is-visible', c.item_count > 0);
                });
              });
          }
          setTimeout(function () {
            addAllBtn.innerHTML = orig;
            addAllBtn.disabled = false;
            updateUI();
          }, 2000);
        } else {
          addAllBtn.innerHTML = orig;
          addAllBtn.disabled = false;
        }
      } catch (e) {
        addAllBtn.innerHTML = orig;
        addAllBtn.disabled = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    

(function () {

  var page = document.querySelector('.srp-page');
  if (!page) return;

  /* -- Sidebar -- */
  var sidebar = document.getElementById('srp-sidebar');
  var overlay = document.getElementById('srp-sidebar-overlay');

  if (sidebar && overlay) {
    function openSidebar() {
      sidebar.classList.add('is-open');
      overlay.classList.add('is-open');
      overlay.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      document.querySelectorAll('[data-srp-sidebar-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }

    function closeSidebar() {
      sidebar.classList.remove('is-open');
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.querySelectorAll('[data-srp-sidebar-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    document.querySelectorAll('[data-srp-sidebar-toggle]').forEach(function (btn) {
      btn.addEventListener('click', openSidebar);
    });
    document.querySelectorAll('[data-srp-sidebar-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSidebar);
    });
    overlay.addEventListener('click', closeSidebar);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeSidebar();
    });
  }

  /* -- Filter group accordion -- */
  function bindFilterGroups() {
    document.querySelectorAll('.srp-filter-group__toggle').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var group = btn.closest('.srp-filter-group');
        var isOpen = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(isOpen));
      });
    });
  }
  bindFilterGroups();

  /* Re-bind after AJAX filter */
  document.addEventListener('srp:filtered', function () { bindFilterGroups(); });

  /* -- Show more / less -- */
  function bindShowMore() {
    document.querySelectorAll('[data-show-more]').forEach(function (btn) {
      if (btn.dataset.showBound) return;
      btn.dataset.showBound = '1';
      var list = btn.closest('.srp-filter-group__body').querySelector('.srp-filter-value-list');
      if (!list) return;
      var showLabel = btn.querySelector('.srp-filter-show-more__label').textContent;

      btn.addEventListener('click', function () {
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        list.querySelectorAll('.srp-filter-value-item--hidden').forEach(function (item) {
          item.classList.toggle('is-visible', !isExpanded);
        });
        btn.setAttribute('aria-expanded', String(!isExpanded));
        var labelEl = btn.querySelector('.srp-filter-show-more__label');
        labelEl.textContent = isExpanded ? showLabel : (btn.dataset.lessText || 'Show less');
      });
    });
  }
  bindShowMore();
  document.addEventListener('srp:filtered', function () { bindShowMore(); });

  /* -- Price range slider -- */
  function bindPriceSlider(root) {
    root.querySelectorAll('[data-price-slider]').forEach(function (wrap) {
      if (wrap.dataset.sliderBound) return;
      wrap.dataset.sliderBound = '1';
      var minThumb  = wrap.querySelector('.srp-price-range-thumb--min');
      var maxThumb  = wrap.querySelector('.srp-price-range-thumb--max');
      var fill      = wrap.querySelector('.srp-price-range-fill');
      var minLabel  = wrap.querySelector('[data-price-min-label]');
      var maxLabel  = wrap.querySelector('[data-price-max-label]');
      var priceWrap = wrap.closest('.srp-price-range-wrap');
      var minInput  = priceWrap ? priceWrap.querySelector('#srp-price-min') : null;
      var maxInput  = priceWrap ? priceWrap.querySelector('#srp-price-max') : null;
      var symbol    = minLabel ? minLabel.textContent.replace(/[\d.,]+/g, '').trim() : '';

      function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), hi); }

      function upd() {
        var lo = parseFloat(minThumb.min), hi = parseFloat(minThumb.max);
        var mn = parseFloat(minThumb.value), mx = parseFloat(maxThumb.value);
        fill.style.left  = ((mn - lo) / (hi - lo) * 100) + '%';
        fill.style.width = ((mx - mn) / (hi - lo) * 100) + '%';
        if (minLabel) minLabel.textContent = symbol + mn;
        if (maxLabel) maxLabel.textContent = symbol + mx;
      }

      minThumb.addEventListener('input', function () {
        minThumb.value = clamp(parseFloat(minThumb.value), parseFloat(minThumb.min), parseFloat(maxThumb.value) - 1);
        if (minInput) minInput.value = minThumb.value;
        upd();
      });
      maxThumb.addEventListener('input', function () {
        maxThumb.value = clamp(parseFloat(maxThumb.value), parseFloat(minThumb.value) + 1, parseFloat(maxThumb.max));
        if (maxInput) maxInput.value = maxThumb.value;
        upd();
      });
      upd();
    });
  }
  bindPriceSlider(document);
  document.addEventListener('srp:filtered', function () { bindPriceSlider(document); });

  /* -- Fix tab active state from URL -- */
  var urlType = new URLSearchParams(window.location.search).get('type') || 'product';
  document.querySelectorAll('.srp-tab').forEach(function (tab) {
    var href = tab.getAttribute('href') || '';
    var qi = href.indexOf('?');
    var tabType = qi > -1 ? (new URLSearchParams(href.slice(qi + 1)).get('type') || 'product') : 'product';
    tab.classList.toggle('is-active', tabType === urlType);
  });

  /* -- Sort select -- */
  var sortSel = document.querySelector('[data-srp-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      /* If filter JS is loaded, it handles AJAX sort via form */
      if (window.Marketly && window.Marketly.applySearchFilters) {
        var form = document.getElementById('search-filters');
        var hidden = form ? form.querySelector('input[name="sort_by"]') : null;
        if (hidden) { hidden.value = sortSel.value; }
        window.Marketly.applySearchFilters();
        return;
      }
      /* Fallback: navigate, preserving all current URL params */
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }

  /* -- Lazy-load filter JS on first filter interaction -- */
  var filterLoaded = false;
  var form = document.getElementById('search-filters');

  function loadFilterJs(triggerEl) {
    if (filterLoaded || !page.dataset.srpFilterJs) return;
    filterLoaded = true;
    var script = document.createElement('script');
    script.src = page.dataset.srpFilterJs;
    script.addEventListener('load', function () {
      if (triggerEl && triggerEl.type === 'checkbox') {
        triggerEl.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (sortSel) {
        sortSel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    document.head.appendChild(script);
  }

  if (form) {
    form.addEventListener('change', function handler(e) {
      if (e.target.classList.contains('srp-filter-value-cb')) {
        form.removeEventListener('change', handler);
        loadFilterJs(e.target);
      }
    });
  }

  /* -- Grid / List view toggle -- */
  var SRP_VIEW_KEY = 'srp_view';
  var grid = document.querySelector('.srp-grid');
  var viewBtns = document.querySelectorAll('[data-view]');

  function applyView(view) {
    if (!grid) return;
    if (view === 'list') {
      grid.classList.add('srp-grid--list');
    } else {
      grid.classList.remove('srp-grid--list');
    }
    viewBtns.forEach(function (btn) {
      var active = btn.dataset.view === view;
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  var savedView;
  try { savedView = localStorage.getItem(SRP_VIEW_KEY); } catch (e) {}
  if (savedView) applyView(savedView);

  viewBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var view = btn.dataset.view;
      try { localStorage.setItem(SRP_VIEW_KEY, view); } catch (e) {}
      applyView(view);
    });
  });

  /* After AJAX filter: re-apply saved view to new grid */
  document.addEventListener('srp:filtered', function () {
    grid = document.querySelector('.srp-grid');
    var v;
    try { v = localStorage.getItem(SRP_VIEW_KEY); } catch (e) {}
    if (v) applyView(v);
  });

  /* -- Load more / Infinite scroll -- */
  var srp = document.getElementById('srp-results');
  if (!srp) return;

  var loadingStyle = srp.dataset.loadingStyle;
  if (loadingStyle !== 'load_more' && loadingStyle !== 'infinite') return;

  var isLoading = false;

  function fetchPage(url) {
    if (isLoading || !url) return;
    isLoading = true;

    var btn      = srp.querySelector('[data-srp-load-btn]');
    var wrap     = srp.querySelector('.srp-load-more-wrap');
    var sentinel = srp.querySelector('.srp-sentinel');

    if (btn) {
      btn.disabled = true;
      var label   = btn.querySelector('.srp-load-more__label');
      var spinner = btn.querySelector('.srp-load-more__spinner');
      if (label)   label.hidden   = true;
      if (spinner) spinner.hidden = false;
    }

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('fetch failed');
        return r.text();
      })
      .then(function (html) {
        var parser  = new DOMParser();
        var doc     = parser.parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.srp-grid');
        var curGrid = srp.querySelector('.srp-grid');

        if (newGrid && curGrid) {
          Array.from(newGrid.children).forEach(function (child) {
            curGrid.appendChild(child);
          });
        }

        var nextEl  = doc.querySelector('[data-next-url]');
        var nextUrl = nextEl ? nextEl.dataset.nextUrl : '';

        if (wrap)     wrap.dataset.nextUrl     = nextUrl;
        if (sentinel) sentinel.dataset.nextUrl = nextUrl;

        if (btn) {
          if (nextUrl) {
            btn.disabled = false;
            var l2 = btn.querySelector('.srp-load-more__label');
            var s2 = btn.querySelector('.srp-load-more__spinner');
            if (l2) l2.hidden = false;
            if (s2) s2.hidden = true;
          } else if (wrap) {
            wrap.hidden = true;
          }
        }

        if (sentinel) {
          var spinnerEl = sentinel.querySelector('.srp-sentinel__spinner');
          if (spinnerEl) spinnerEl.hidden = !nextUrl;
        }
      })
      .catch(function () {
        window.location.href = url;
      })
      .finally(function () { isLoading = false; });
  }

  if (loadingStyle === 'load_more') {
    srp.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-srp-load-btn]');
      if (!btn || btn.disabled) return;
      var wrap = srp.querySelector('.srp-load-more-wrap');
      var url  = wrap ? wrap.dataset.nextUrl : '';
      if (url) fetchPage(url);
    });
  }

  if (loadingStyle === 'infinite') {
    var sentinel = srp.querySelector('.srp-sentinel');
    if (sentinel && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var url = sentinel.dataset.nextUrl;
            if (url) fetchPage(url);
            else observer.unobserve(sentinel);
          }
        });
      }, { rootMargin: '300px' });
      observer.observe(sentinel);
    }
  }

})();


  } catch(e) { console.error(e); }
})();
})();
